<template>
  <section class="hero is-bold app-navbar animated" :class="{ slideInDown: show, slideOutDown: !show }">
    <div class="hero-head">
      <nav class="nav">
        <div class="nav-left">
          <a class="nav-item is-hidden-tablet" @click="toggleSidebar({opened: !sidebar.opened})"> <i class="fa fa-bars" aria-hidden="true" v-show="!sidebar.hidden"></i>
          </a>
        </div>
        <div class="nav-center">
          <a class="nav-item hero-brand" href="/">
            <img src="~assets/samsung.svg" :alt="pkginfo.description">
            <tooltip :label="'v' + pkginfo.version" placement="right" type="success" size="small" :no-animate="true" :always="true" :rounded="true">
              <div class="is-hidden-mobile">
                <span class="vue">Home IoT</span><strong class="admin"> Reference Server {{ stage }}</button></strong>
              </div>
            </tooltip>
          </a>
        </div>
        <div class="nav-right is-flex">
          <a class="button" @click="login('facebook')" v-if="!$auth.check()">
            <span class="icon">
              <i class="fab"></i>
            </span>
            <span>Login with OAuth2</span>
          </a>
          <button :class="btnClass" v-popover:user v-if="$auth.check()">Welcome {{ username() }}</button>
          <popover name="user" v-if="$auth.check()">
            <div align="right">
              <ul class="menu-item">
                <li v-if="isAdmin">Logged-in as an admin</li>
                <li v-if="isDev">Logged-in as a Developer</li>
                <li v-if="!isAdmin && !isDev">Logged-in as a Resident</li>
                <!-- <li><router-link to="/setting">Settings</router-link></li> -->
                <!-- <li><router-link to="/auth/personal-token">Personal access token</router-link></li> -->
                <hr/>
                <li><button class="button button-menu is-danger is-small" @click="logout()">Logout</button></li>
              </ul>
            </div>
          </popover>
        </div>
      </nav>
    </div>
  </section>
</template>


<script>
import Tooltip from 'vue-bulma-tooltip'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: { Tooltip
  },
  props: {
    show: Boolean
  },
  computed: mapGetters({
    pkginfo: 'pkg',
    sidebar: 'sidebar'
  }),
  data () {
    return {
      stage: '',
      context: 'oauth2 context',
      code: this.$route.query.code,
      type: 'facebook',
      data: {
        rememberMe: 'false'
      },
      isAdmin: false,
      isDev: false,
      btnClass: 'button'
    }
  },
  mounted () {
//    this.configure()
    if (this.code) {
      // console.log('I have authorization code')
      this.$auth.oauth2({
        code: true,
        provider: this.type,
        makeRequest: true,
        fetchUser: false,
//        rememberMe: false,
//        state: false,
        params: {
          code: this.code
//          state: '12345'
        },
        success: function (res) {
          this.code = null
          this.isAdmin = this.isGroupMember('admin')
          this.isDev = this.isGroupMember('homenet-dev')
          if (this.isAdmin) {
            this.btnClass = 'button is-danger'
          } else if (this.isDev) {
            this.btnClass = 'button is-warning'
          } else {
            this.btnClass = 'button is-primary'
          }
        },
        error: function (res) {
          console.log('error ' + this.context)
        }
      })
    } else {
      this.isAdmin = this.isGroupMember('admin')
      this.isDev = this.isGroupMember('homenet-dev')
      if (this.isAdmin) {
        this.btnClass = 'button is-danger'
      } else if (this.isDev) {
        this.btnClass = 'button is-warning'
      } else {
        this.btnClass = 'button is-primary'
      }
    }
  },
  methods: {
    ...mapActions([
      'toggleSidebar'
    ]),
    username () {
      if (this.$auth.check()) {
        return this.$auth.watch.data.username
      } else {
        return null
      }
    },
    role () {
      if (this.$auth.check()) {
        return this.$auth.watch.data.role
      } else {
        return null
      }
    },
    isGroupMember (groupname) {
      if (this.$auth.check()) {
        for (let i = 0; i < this.$auth.watch.data['cognito:groups'].length; i++) {
          if (this.$auth.watch.data['cognito:groups'][i] === groupname) return true
        }

        return false
      } else {
        return false
      }
    },
    logout () {
      this.$http.get(this.$store.state.api.logout).then((response) => {
        console.log('logged out')
      })
      .then(() => {
        this.$auth.logout({
          redirect: {name: 'Home'},
          makeRequest: false
          // params: {},
          // success: function () {},
          // error: function () {},
          // etc...
        })
      })
      .then(() => {
        console.log('auth logged out')
        let baseUrl = 'https://homeiottf-dev.auth.ap-northeast-2.amazoncognito.com'
        let clientId = 'lfms21abk334e3i1lnkpr70ep'
        let callbackUrl = 'https://www.homeiottf.com'
        let logoutUrl = baseUrl + '/logout?client_id=' + clientId + '&logout_uri=' + callbackUrl
        window.location.href = logoutUrl
      })
      .catch((error) => {
        this.$auth.logout({
          redirect: {name: 'Home'},
          makeRequest: false
          // params: {},
          // success: function () {},
          // error: function () {},
          // etc...
        })
        console.log('auth error:', error)
      })
    },

    login (type) {
      // need to check type is null or not
      // console.log('I need code')
      this.$auth.oauth2({
        provider: type || this.type,
        success (res) {
          console.log('Auth Success')
        },
        error (err) {
          if (err.response) {
            // The request was made, but the server responded with a status code
            // that falls out of the range of 2xx
            this.error = err.response.data
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', err.message)
          }
          console.log(err.config)
        }
      })
    }
  }
}
</script>

<style lang="scss">
@import '~bulma/sass/utilities/variables';

.app-navbar {
  position: fixed;
  min-width: 100%;
  z-index: 1024;
  box-shadow: 0 2px 3px rgba(17, 17, 17, 0.1), 0 0 0 1px rgba(17, 17, 17, 0.1);

  .container {
    margin: auto 10px;
  }

  .nav-right {
    align-items: stretch;
    align-items: stretch;
    flex: 1;
    justify-content: flex-end;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    margin-right: 40px;
  }
}

.hero-brand {
  .vue {
    margin-left: 10px;
    color: #36AC70;
  }
  .admin {
    color: #28374B;
  }
}

.button {
  margin: 10px 0 0;
}
.button-menu {
  margin: 0 0 0;
}

$blue600: #1e88e5;
$gray74: #bdbdbd;
$gray93: #ededed;
$gray98: #fafafa;
.menu-item {
  ul {
    list-style: none;
    padding: 10px 0;
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    li {
      margin: 0;
      padding: 10px 35px;
      cursor: pointer;
      hover {
        background: $blue600;
        color: $gray98;
      }
    }
  }
  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 3px;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Navbar.vue?a86a3710